export const LOADING_ITEM = "LOADING_ITEM";

export const POST_INCOME = "POST_INCOME";
export const DELETE_INCOME = "DELETE_INCOME";
export const UPDATE_INCOME = "UPDATE_INCOME";
export const GET_INCOME_LIST = "GET_INCOME_LIST";
